import React from 'react';
import { Box, Flex, SimpleGrid, Text } from '@chakra-ui/react';
import StatCard from '../../../components/utils/StatCard';
import SociosCards from './SociosCards';
import { MdGroupAdd, MdOutlinePeople, MdOutlineCheckCircle, MdOutlineSupervisorAccount, MdOutlinePersonOff } from "react-icons/md";
import { Button } from "components/ui/Button";

const Socios = () => {
  return (
    <Box display="flex" flexDirection="column" gap="5" h="full" overflow="hidden">
      <Flex
        flexShrink={0}
        direction={{ base: "column", md: "row" }}
        align={{ base: "stretch", md: "center" }}
        justify="space-between"
        gap="4"
      >
        <Box>
          <Text
            fontFamily="display"
            fontWeight="700"
            fontSize={{ base: "2xl", md: "3xl" }}
            color="dashboard.fg.default"
            lineHeight="1.1"
          >
            Socios
          </Text>
          <Text fontSize="sm" color="dashboard.fg.muted" mt="0.5">
            Bienvenido a tus Socios
          </Text>
        </Box>

        <Button color="red" variant="solid" radius="xl" fontSize="lg" alignSelf={{ base: "stretch", md: "auto" }}>
          <MdGroupAdd />
          Agregar socio
        </Button>
      </Flex>

      <SimpleGrid columns={[2, 4]} gap="2" flexShrink={0}>
        <StatCard title="Socios Registrados"   data="28" icon={MdOutlinePeople}           tone="info"    sub="+2 este mes" />
        <StatCard title="Asistencia Promedio"  data="11" icon={MdOutlineCheckCircle}       tone="success" sub="78% del grado" />
        <StatCard title="Preceptorías"         data="8"  icon={MdOutlineSupervisorAccount} tone="warning" sub="Promedio mensual" />
        <StatCard title="Sin Registrar"        data="10" icon={MdOutlinePersonOff}         tone="danger"  sub="Pendientes de alta" />
      </SimpleGrid>

      <SociosCards />
    </Box>
  );
};

export default Socios;
